import { createSlice } from '@reduxjs/toolkit';
import { fetchOnlineFreeUsers } from './operations';

const initialState = {
  items: [],
  filterItems: [],
  filterItemsPagination: { page: 1, perPage: 20 },
  isLoading: false,
  error: null,
};
const handlePending = state => {
  state.isLoading = true;
  state.error = null;
};
const handleRejected = (state, { payload }) => {
  state.isLoading = false;
  state.error = payload;
};

export const sliceOnlineFreeUsers = createSlice({
  name: 'OnlineFreeUsers',
  initialState,
  reducers: {
    setFilterItems(state, { payload: userData }) {
      state.filterItems = userData;
    },
    setFilterItemsPagination(state, { payload: userData }) {
      state.filterItemsPagination = userData;
    },
    updateFilterItemFreeUser(state, { payload: { userId, ...data } }) {
      const index = state.filterItems.findIndex(el => el._id === userId);
      state.filterItems[index] = { ...state.filterItems[index], ...data };
    },
    removeItem(state, { payload: userId }) {
      state.filterItems = state.filterItems.filter(el => el._id !== userId);
    },
  },

  extraReducers: builder => {
    builder
      .addCase(
        fetchOnlineFreeUsers.fulfilled,
        (state, { payload: userData }) => {
          state.isLoading = false;
          state.error = null;
          state.items = userData;
        },
      )

      .addCase(fetchOnlineFreeUsers.pending, handlePending)
      .addCase(fetchOnlineFreeUsers.rejected, handleRejected);
  },
});
export const {
  setFilterItems,
  setFilterItemsPagination,
  updateFilterItemFreeUser,
  removeItem,
} = sliceOnlineFreeUsers.actions;
export default sliceOnlineFreeUsers.reducer;
